/**
 * 估价详情 cover
 * 
 * @Author: Focci
 * @Date: 2023-12-03 17:07:14
 * @Last Modified by: Focci
 * @Last Modified time: 2023-12-03 17:07:14
 */

'use client'

import PropTypes from 'prop-types'
import useLazyComponent from '@hook/useLazyComponent'
import useApp from '@hook/useApp'
import { useCallback, useEffect, useMemo } from 'react'
import { Waypoint } from 'react-waypoint'
import { isWindow } from '@lib/utils'
import { PropertyStatusMaks } from '@comp/page/common/card/property/StatusMask'
import clsx from 'clsx'

export default function EstimateSoldCover({
  house = {}
}) {
  const { isMobile } = useApp()
  const hasCover = !!house.cover
  const hasMap = useMemo(() => !!(house.lng && house.lat), [house])

  const { Wedget: CoverForPC, getWedget: getCoverForPC } = useLazyComponent()
  const { Wedget: CoverForResponsive, getWedget: getCoverForResponsive } = useLazyComponent()

  const handleEnter = useCallback(() => {
    if(!isMobile) {
      getCoverForPC(() => import('./CoverForPC'))
    } else {
      getCoverForResponsive(() => import('./CoverForResponsive'))
    }
  }, [isMobile, getCoverForPC, getCoverForResponsive])

  useEffect(() => {
    isWindow && window.addEventListener('resize', handleEnter, false)
    return () => {
      isWindow && window.removeEventListener('resize', handleEnter, false)
    }
  }, [handleEnter])

  if(!hasCover && !hasMap) {
    return null
  }

  return (
    <Waypoint onEnter={handleEnter}>
      <div className="overflow-hidden bg-cf0 relative">
        <div 
          className={clsx([
            'relative w-full md:h-[32rem] max-w-[1680px] mx-auto',
            !hasCover && hasMap ? 'min-h-[70vh]' : 'min-h-[16rem]'
          ])}
        >
          {!isMobile && (
            <CoverForPC 
              house={house}
              hasCover={hasCover}
              hasMap={hasMap}
            />
          )}
          {isMobile && (
            <CoverForResponsive 
              house={house}
              hasCover={hasCover}
              hasMap={hasMap}
            />
          )}
        </div>
        <PropertyStatusMaks 
          status={house.status} 
          className="text-[2rem]" 
        />
      </div>
    </Waypoint>
  )
}

EstimateSoldCover.propTypes = {
  house: PropTypes.object,
}
